import React, { useEffect } from "react";
import { useState } from "react";
import data from "../data/multilanguage.json";
import frenchData from "../data/fr.json";

export const LanguageContext = React.createContext({
  language: "en" || "fr",
  frenchLanguage: null,
  changeWebsiteLanguage: () => {},
  currency: "$" || "€",
});
let userLang = navigator.language || navigator.userLanguage;
userLang.includes("fr") ? (userLang = "fr") : (userLang = "en");

const LanguageProvider = (props) => {
  const [language, setLanguage] = useState(
    localStorage.getItem("language") === "fr"
      ? {
          content: frenchData[0]["fr"],
          label: "fr",
        }
      : sessionStorage.getItem("language") === "en"
      ? {
          content: data[0]["en"],
          label: "en",
        }
      : userLang === "fr"
      ? {
          content: frenchData[0]["fr"],
          label: "fr",
        }
      : userLang === "en"
      ? {
          content: data[0]["en"],
          label: "en",
        }
      : {
          content: data[0]["en"],
          label: "en",
        }
  );
  const [currency, setCurrency] = useState("€");
  useEffect(() => {
    if (!localStorage.getItem("language")) {
      localStorage.setItem("language", userLang);
    }
  }, []);
  useEffect(() => {
    if (language.label === "fr") {
      setCurrency("€");
    } else {
      setCurrency("$");
    }
  }, [language]);
  const [frenchLanguage, setFrenchLanguage] = useState(
    userLang === "fr" ? language : { content: frenchData[0]["fr"], label: "fr" }
  );
  const changeWebsiteLanguage = (value) => {
    value === "fr" && getFrenchContent(value);
    value === "en" && setLanguage({ content: data[0]["en"], label: "en" });
    localStorage.setItem("language", value);
  };
  const getFrenchContent = (value) => {
    if (frenchLanguage !== null) {
      setLanguage(frenchLanguage);
      return;
    }
    fetch(`/src/data/${value}.json`, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (myJson) {
        // setLanguage(myJson);
        setLanguage({ content: myJson[0]["fr"], label: "fr" });
        setFrenchLanguage({ content: myJson[0]["fr"], label: "fr" });
      });
  };

  return (
    <LanguageContext.Provider
      value={{ language, changeWebsiteLanguage, frenchLanguage, currency }}
    >
      {props.children}
    </LanguageContext.Provider>
  );
};
export default LanguageProvider;
